<template>
  <div class="groupBox">
    <div class="bg"></div>
    <div class="bg1"></div>
    <div class="content">
      <div class="info">
        <p class="name">{{ info.name }}</p>
        <p class="tip">学习交流群</p>
        <!-- <p class="people">
          {{ util.showCount(info.studyqrcodecount) }}人已入群
        </p> -->
      </div>
      <div class="img">
        <img :src="info.studyqrcode" alt />
        <p class="tip">长按二维码入群</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "加入课程学习群",
  },
  name: "group",
  data() {
    return {
      courseType: "",
      courseid: "",
      info: "",
    };
  },
  mounted() {
    this.courseType = this.$route.query.courseType
      ? this.$route.query.courseType
      : "";
    this.courseid = this.$route.query.courseid
      ? this.$route.query.courseid
      : "";
    this.getInfo();
  },
  methods: {
    getInfo() {
      var obj = {},
        url = "";
      if (this.courseType == 1000) {
        obj = { courseid: this.courseid };
        url = "iart-api-scm/api/scm/course/queryByCourse";
      } else {
        obj = { packageid: this.courseid };
        url = "iart-api-scm/api/scm/package/queryCosPackInfo";
      }
      this.$post(url, obj).then((res) => {
        if (res.code == 1) {
          this.info = res.data;
        } else {
          this.util.showToast({ msg: res.message });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.groupBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(244, 244, 247, 1);
  overflow-y: auto;
  overflow-x: hidden;
  .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    margin: 10vh 32px 0;
    background: #fff;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.06);
    .info {
      padding: 24px;
      border-bottom: 0.5px solid rgba(224, 224, 224, 1);
      .tip {
        font-size: 22px;
        line-height: 30px;
        color: rgba(53, 54, 60, 1);
        font-weight: bolder;
        margin-top: 8px;
      }
      .name {
        font-size: 16px;
        line-height: 22px;
        color: rgba(53, 54, 60, 1);
      }
      .people {
        font-size: 12px;
        line-height: 17px;
        color: rgba(174, 175, 177, 1);
        margin-top: 16px;
      }
    }
    .img {
      text-align: center;
      padding: 24px;
      img {
        width: 260px;
        height: 260px;
      }
      .tip {
        font-size: 12px;
        line-height: 17px;
        color: rgba(174, 175, 177, 1);
        margin-top: 16px;
      }
    }
  }
}
.bg {
  width: 100%;
  height: 40vh;
  background: rgba(201, 55, 61, 1);
  position: relative;
  z-index: 1;
}
.bg1 {
  height: 20vh;
  width: 120%;
  margin-left: -10%;
  background: #c9373d;
  border-radius: 0 0 80% 80%;
}
</style>